import { useDispatch, useSelector } from "react-redux";
import { VDOARCHIVE } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Container,
  Card,
  Grid,
  Typography,
  Box,
  Pagination,
} from "@mui/material";
import {
  COMPANY,
  PROJECT,
  TIMELAPSE,
  VIDEOZIP,
  VIDEOZIPALL,
} from "../../services/actions";
import VDOForm from "./VDOForm";
import ProgressBar from "../extra/ProgressBar";
import InfoCard2 from "../extra/InfoCard2";
import logoPng from "./videologo.png";

const formattedDate = (isoString) => {
  try {
    const date = new Date(isoString);
    const fd = date.toISOString().split("T")[0]; // "2025-05-23"
    const day = date.getUTCDate(); // returns 23
    console.log(day);
    return { date: fd, day: day };
  } catch (err) { }
};
export default function VideoArchive() {
  const documentStyle = getComputedStyle(document.documentElement);
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = React.useState(false);
  let projectState = useSelector((state) => state?.projectState);
  let companyState = useSelector((state) => state?.companyState);
  let timelapseState = useSelector((state) => state?.timelapseState);
  let videozipallState = useSelector((state) => state?.videozipallState);
  let videozipState = useSelector((state) => state?.videozipState);
  const [companies, setCompanies] = React.useState([]);
  let user = useSelector((state) => state?.loginState?.auth);
  const [defV, setDefV] = React.useState({});
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchVideoArchives = (page = 0) => {
    const url = page === 0 ? `video-zip/${page}/` : `video-zip/?page=${page}`; // pass page number
    dispatch({ type: `${VIDEOZIPALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    try {
      if (user.main_role == "Company") {
        setCompanies(user?.companies);
      } else {
        dispatch({ type: `${COMPANY}_GET`, payload: 0 });
      }
      //dispatch({ type: `${VIDEOZIPALL}_GET`, payload: 0 })
      fetchVideoArchives(0);
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchVideoArchives(page);
  }, [page]);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results);
  }, [companyState?.data]);

  React.useEffect(() => {
    setLoader(false);
    dispatch({ type: `${VIDEOZIPALL}_GET`, payload: 0 });
  }, [videozipState.data]);

  const handleFormOpen = () => { };
  const handleDelete = (id) => {
    dispatch({ type: `${VIDEOZIP}_DELETE`, payload: id });
  };

  return (
    <>
      <Container maxWidth="false" className="py-3">
        <Grid container spacing={2}>
          <Grid size={{ md: 12 }} >
            <Card sx={{ borderRadius: 4, px: 3, py: 2, background: "#ffffff8f", mb: 1, mt: 3 }}>
              <VDOForm
                companies={companies}
                projects={projectState?.data?.results}
                cameras={timelapseState?.data?.results}
                defaultValues={defV}
                onSubmit={(data) => {
                  setLoader(true);
                  let ACTION = data.id ? `${VIDEOZIP}_PATCH` : `${VIDEOZIP}_POST`;
                  dispatch({ type: ACTION, payload: data });
                }}
                onChange={(action, value) => {
                  console.log(action, value);
                  if (value) {
                    if (action == "project") {
                      dispatch({
                        type: `${TIMELAPSE}_GET`,
                        payload: `timelapse/0/?filter_by={"project":"${value}"}`,
                      });
                    } else {
                      dispatch({
                        type: `${PROJECT}_GET`,
                        payload: `project/0/?filter_by={"company":"${value}"}`,
                      });
                    }
                  }
                }}
              />
            </Card>
            {loader && <ProgressBar />}
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ py: 3 }}>
          {(videozipallState?.data?.results || []).map((data) => {
            const _from = formattedDate(data.date_from);
            const _to = formattedDate(data.date_to);
            data.to_day = _to.day;
            data.from_day = _from.day;
            data.date = _from.date + "-" + _to.date;
            data.image = logoPng;
            data.fname = data.company_name + " " + data.project_name;
            return (
              <>
                <Grid size={{ xs: 12, sm: 2, md: 3 }}>
                  <InfoCard2
                    img_type={"company"}
                    keys={[
                      "image",
                      "camera_name",
                      "fname",
                      "date",
                      "From",
                      "from_day",
                      "Up To",
                      "to_day",
                      "Videos",
                      "file_count",
                    ]}
                    data={data}
                    onClick={() => {
                      // navigate if needed
                    }}
                    onAction={(action) => {
                      if (action === "Edit") {
                        handleFormOpen(data);
                      } else if (action === "Delete") {
                        handleDelete(data.id);
                      }
                    }}
                  />

                  <Box sx={{ textAlign: "center", px: 3, my: 1 }} className="input-label">
                    {data.zip_url && (
                      <a download href={data?.zip_url}>
                        Click here to download
                      </a>
                    )}
                  </Box>
                </Grid>
              </>
            );
          })}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(videozipallState?.data?.count / pageSize)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </Container>
    </>
  );
}
